import { requestPhoenix } from '../network';
import { KalturaHouseholdQuota } from '../objects';

/**
 * @see https://latest.api-docs-develop.ott.kaltura.com/api-docs/service/householdQuota/action/get
 */
export async function fetchHouseholdQuota() {
  return requestPhoenix<KalturaHouseholdQuota>({
    path: '/householdquota/action/get',
  });
}
